goog.provide("shadow.js.shim.module$src$svg$objects$tag_svg$default");
shadow.js.shim.module$src$svg$objects$tag_svg$default = shadow.js.shim.module$src$svg$objects$tag_svg.default;
